"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * This is a factory for creating a helper for setting and unsetting listeners
 * on entities (e.g. models and collections) where they share the same callback
 * and context.
 *
 * @param {function} callback
 * @param {Object} context - The context to execute the callback in
 * @returns {Object}
 */
var _default = function (callback, context) {
  return {
    on: function on(entities, events) {
      return entities.forEach(function (entity) {
        return entity.on(events, callback, context);
      });
    },
    off: function off(entities, events) {
      return entities.forEach(function (entity) {
        return entity.off(events, callback, context);
      });
    }
  };
};

exports.default = _default;